import { render, staticRenderFns } from "./DashboardSalesRadarChart.vue?vue&type=template&id=84f15c72&"
import script from "./DashboardSalesRadarChart.vue?vue&type=script&lang=js&"
export * from "./DashboardSalesRadarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports